import $ from 'jquery'
import {
  clearRefinements,
} from 'instantsearch.js/es/widgets'

const object = vnObject;

var catSelect = $('.js-cat-select')
var trainingCenterSelect = $('.js-tc-select')
var blogSection = $('.js-posts-container')
var paginateSection = $('.js-paginate')
var termsArray = []
if ( $('.js-cat-array').val() ) {
  termsArray = $('.js-cat-array').val().split(',')
}
var trainingCentersArray = []
if ( $('.js-tc-array').val() ) {
  trainingCentersArray = $('.js-tc-array').val().split(',')
}

catSelect.on('change', function () {
  if ($(this).is(':checked')) {
    termsArray.push( $(this).val() )
    $(this).attr('checked', true)
    $(this).parent().find('.vn-custom-checkbox').addClass('checked');
  } else {
    termsArray.splice( $.inArray( $(this).val() , termsArray), 1 )
    $(this).removeAttr('checked')
    $(this).parent().find('.vn-custom-checkbox').removeClass('checked');
  }
  post_search()
} );

trainingCenterSelect.on('change', function () {
  if ($(this).is(':checked')) {
    trainingCentersArray.push( $(this).val() )
    $(this).attr('checked', true)
    $(this).parent().find('.vn-custom-checkbox').addClass('checked');
  } else {
    trainingCentersArray.splice( $.inArray( $(this).val(), trainingCentersArray), 1);
    $(this).removeAttr('checked')
    $(this).parent().find('.vn-custom-checkbox').removeClass('checked');
  }
  post_search()
})

$('.js-reset-filter').on('click', function () {
  $('.vn-custom-checkbox').removeClass('checked');

  catSelect.removeAttr('checked')
  trainingCenterSelect.removeAttr('checked')

  trainingCentersArray = []
  termsArray = []

  post_search()
})

function post_search () {
  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: {
      nonce: object.nonce,
      action: 'vn_post_search',
      term: termsArray,
      trainingCenters: trainingCentersArray,
      post: 'post',
      taxo: 'category',
    },
    success: function (res) {
      if (res.length !== 0) {
        blogSection.html('')
        paginateSection.html(res.data.paginate)
        res.data.data.forEach((item, index) => {
          blogSection.append(item)
        })
      }
    },
  });
}

